<script>
import vueFilePond from 'vue-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import { rbxAuthToken } from '../../config';

const { VUE_APP_API_ENDPOINT } = process.env;

export default {
  name: 'RbxFileUpload',
  components: {
    FilePond: vueFilePond(FilePondPluginFileValidateType),
  },
  props: {
    domain: {
      type: String,
      required: false,
      default: '',
    },
    action: {
      type: String,
      default: 'save',
    },
    fileResource: { /* Define an alternative resource for the file upload. */
      type: String,
      default: 'ufile',
    },
    referenceId: {
      type: [String, Number],
      required: false,
      default: '',
    },
    params: { /* Additional parameters for the request. */
      type: [Object, Array],
      required: false,
      default: () => [],
    },
    options: {
      type: Object,
      default() {
        return {};
      },
    },
    allowMultiple: {
      type: Boolean,
      default: true,
    },
    acceptedTypes: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      defaultOptions: {
        labelIdle: 'Drag & Drop oder <span class="filepond--label-action"> Klick </span>',
        allowMultiple: this.allowMultiple,
        allowReplace: false,
        allowRevert: false,
        allowBrowse: true,
        // acceptedFileTypes: this.acceptedTypes,
      },
    };
  },
  computed: {
    token() {
      return localStorage.getItem(rbxAuthToken);
    },
    server() {
      const {
        domain, action, referenceId, token, fileResource, params,
      } = this;

      const url = new URL(`${VUE_APP_API_ENDPOINT}/${fileResource}`);

      url.searchParams.append('domain', domain);
      url.searchParams.append('action', action);
      if (referenceId) url.searchParams.append('referenceId', referenceId);

      if (params) {
        params.forEach((it) => { url.searchParams.append(it[0], it[1]); });
      }

      return {
        process: {
          url: url.href,
          method: 'POST',
          headers: {
            Authorization: `Basic ${token}`,
          },
        },
      };
    },
    mergedOptions() {
      return {
        ...this.defaultOptions,
        ...this.options,
      };
    },
  },
  created() {
    if (this.acceptedTypes) {
      this.defaultOptions = { ...this.defaultOptions, acceptedFileTypes: this.acceptedTypes };
    }
  },
  methods: {
    processFile(err, file) {
      if (!err && file) {
        this.$emit('uploaded', [file, err]);
      }
    },
    addFile(err, file) {
      if (!err && file) {
        this.$emit('addfile', [file, err]);
      }
    },
    onError(err, file) {
      this.$emit('error', [err, file]);
    },
  },
};
</script>

<template>
  <div class="rbx-filepond">
    <file-pond :max-height="50"
               name="file"
               ref="pond"
               v-bind="mergedOptions"
               :server="server"
               @processfile="processFile"
               @addfile="addFile"
               @error="onError"
    />
  </div>
</template>

<style lang="scss">

.rbx-filepond {
  margin-top: 20px;
}
</style>
